import {Injectable} from '@angular/core';
import {
  ActionLogAction,
  ActionLogObjectType,
  ActionLogResult,
  ActionLogTrigger,
  DeviceGroupState,
  DeviceHistoryEventType,
  DeviceType,
  DeviceValueUnit,
  ForecastPeriod,
  NotificationLevel,
  RepetitionMode,
  RuleConditionComparisonType,
  RuleConditionWeather,
  ScenarioHistoryEventType,
  WeekDays
} from '@birco/rainmesh-api';
import {FormConditionType} from '../../features/rules/enums/form-condition-type';

@Injectable({
  providedIn: 'root'
})
export class LabelConverter {

  constructor() {
  }

  static getFormConditionTypeLabel(value: FormConditionType): string {
    return 'rules.detail.conditionType.' + value
  }

  static getRepetitionModeLabel(value: RepetitionMode): string {
    return 'rules.detail.repetitionMode.' + value.toLowerCase()
  }

  static getWeekDaysLabel(value: WeekDays): string {
    return 'rules.detail.repetitionDays.' + value.toLowerCase()
  }

  static getDeviceTypeLabel(value: DeviceType): string {
    return 'devices.deviceType.' + value.toLowerCase()
  }

  static getWeatherLabel(value: RuleConditionWeather): string {
    switch (value) {
      case RuleConditionWeather.SUNNY:
        return 'rules.detail.weather.' + value.toLowerCase()
      case RuleConditionWeather.CLOUDY:
        return 'rules.detail.weather.' + value.toLowerCase()
      case RuleConditionWeather.NO_RAIN:
        return 'rules.detail.weather.noRain'
      case RuleConditionWeather.LIGHT_RAIN:
        return 'rules.detail.weather.lightRain'
      case RuleConditionWeather.MODERATE_RAIN:
        return 'rules.detail.weather.moderateRain'
      case RuleConditionWeather.HEAVY_RAIN:
        return 'rules.detail.weather.heavyRain'
      default:
        return ''
    }
  }

  static getForecastPeriodLabel(value: ForecastPeriod): string {
    return 'rules.detail.forecastPeriod.' + value.toLowerCase()
  }

  static getRuleConditionComparisonTypeLabel(value: RuleConditionComparisonType): string {
    switch (value) {
      case RuleConditionComparisonType.EQUAL:
        return "=";
      case RuleConditionComparisonType.GREATER:
        return ">";
      case RuleConditionComparisonType.LESS:
        return "<";
      default:
        return ""
    }
  }

  static getNotificationLevelLabel(value: NotificationLevel): string {
    return 'notification.level.' + value.toLowerCase()
  }

  static getDeviceValueUnitLabel(value: DeviceValueUnit, withFormatted = true): string {
    if (!withFormatted) {
      switch (value) {
        case DeviceValueUnit.PERCENT:
          return ''
      }
    }
    return 'devices.deviceValueUnit.short.' + value.toLocaleLowerCase()
  }

  static getHistoryEventTypeLabel(value?: DeviceHistoryEventType): string {
    if (!value) {
      return ''
    }

    return 'devices.history.eventType.' + value.toLowerCase()
  }

  static getScenarioHistoryEventTypeLabel(value?: ScenarioHistoryEventType): string {
    if (!value) {
      return ''
    }

    return 'demo.history.eventType.' + value.toLowerCase()
  }

  static getActionLogActionLabel(value: ActionLogAction): string {
    return 'actionLog.action.' + value.toLowerCase()
  }

  static getActionLogTriggerLabel(value: ActionLogTrigger): string {
    return 'actionLog.trigger.' + value.toLowerCase()
  }

  static getActionLogResultLabel(value: ActionLogResult): string {
    return 'actionLog.result.' + value.toLowerCase()
  }

  static getActionLogObjectTypeLabel(value: ActionLogObjectType): string {
    return 'actionLog.objectType.' + value.toLowerCase()
  }

  static getDeviceGroupStateLabel(value?: DeviceGroupState): string {
    switch (value) {
      case DeviceGroupState.ACTIVE:
        return "deviceGroups.state.active";
      case DeviceGroupState.INACTIVE:
        return "deviceGroups.state.inactive";
      case DeviceGroupState.PARTIALLY_ACTIVE:
        return "deviceGroups.state.partiallyActive";
      default:
        return ''
    }
  }

}
